module.exports = __webpack_public_path__ + "fonts/iconfont.9caa86bc.woff2";